var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"my-modal",attrs:{"id":"my-modal","size":_vm.size ? _vm.size : 'md',"hide-footer":"","hide-header":""}},[_vm._t("modal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }